import Parse from 'parse'
Parse.initialize(process.env.VUE_APP_PARSE_APP_ID);
Parse.serverURL = `${process.env.VUE_APP_PARSE_SERVER_URL}`;
Parse.enableEncryptedUser();
Parse.secret = '7FF0C5B5-8847-4866-8402-57015133609C';
export default Parse;